import styles from "./styles.module.scss";
import { useAuth } from "react-oidc-context";
import { useEffect } from "react";

const Login = () => {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading) {
      auth.signinRedirect();
    }
  }, []);

  return <div className={styles.wrapper}></div>;
};

export default Login;
